import React from "react";
import { Helmet } from 'react-helmet';
import { useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../utils/api";
function CreateBlog() {
    const [title, setTitle] = useState('');
    const [date, setDate] = useState('');
    const [tags, setTags] = useState('');
    const [description, setDescription] = useState('');
    const [summary, setSummary] = useState('');
    const [image, setImage] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('title', title);
        formData.append('date', date);
        formData.append('tags', tags);
        formData.append('description', description);
        formData.append('summary', summary);
        if (image) {
            formData.append('image', image);
        }

        try {
            await axios.post(buildApiUrl('/api/createBlog/create'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            //console.log('Blog created successfully:', response.data);
            alert("Blog Created Successfully!!!")
            setTitle("");
            setDate("");
            setTags("");
            setDescription("");
            setSummary("");
            setImage(null);
        } catch (error) {
            console.error('Error creating blog:', error);
        }
    };
    return (
        <>
            <Helmet>
                <title>Create Blog | 3pl Site</title>
            </Helmet>
            <div className="createBlog">
                <h1>CREATE BLOG</h1>
                <div className=" container blogForm shadow-lg mb-5" style={{ width: "50%", borderRadius: "30px" }}>
                    <form className="text-start py-5 px-4" onSubmit={handleSubmit}>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Blog Title</label>
                            <input
                                type="text"
                                className="form-control"
                                id="blogTitle"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Blog Creation Date</label>
                            <input
                                type="date"
                                className="form-control"
                                id="blogCreatedDate"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Related Tags</label>
                            <input
                                type="text"
                                className="form-control"
                                id="blogTags"
                                value={tags}
                                onChange={(e) => setTags(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Short Description</label>
                            <textarea
                                className="form-control"
                                id="blogDescription"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Brief Summary of Blog</label>
                            <textarea
                                className="form-control"
                                id="blogSummary"
                                value={summary}
                                onChange={(e) => setSummary(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label class="form-label" style={{ fontWeight: "bold" }}>Upload Blog Image</label>
                            <input
                                type="file"
                                className="form-control"
                                id="blogImage"
                                onChange={(e) => setImage(e.target.files[0])}
                            />
                            <p style={{color:"#973131"}}>upload image size of 1200 X 800 px</p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <button type="submit" class="btn btn-primary ">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
export default CreateBlog
